'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ReactTypeformEmbed = require('./ReactTypeformEmbed');

Object.defineProperty(exports, 'ReactTypeformEmbed', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ReactTypeformEmbed).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-typeform-embed/lib/index.js
 ** module id = 1575
 ** module chunks = 0
 **/